module.exports = __webpack_public_path__ + "uarm-images/glyphicons-halflings-regular.svg";